module.exports = __webpack_public_path__ + "img/blau-grün fertig.d4f88fa6.jpg";